export default function wordCount(string) {
  return string ? string.trim().split(/\s+/).length : 0;
}
